globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Public = appCustomerSpace.Controllers.Public || {};
appCustomerSpace.Controllers.Public.MainController = appCustomerSpace.Controllers.Public.MainController || {};

appCustomerSpace.Controllers.Public.MainController = (function(superClass) {

    utils.extend(MainController, superClass);

    function MainController() {
        return MainController.__super__.constructor.apply(this, arguments);
    }

    $.extend(MainController.prototype, {
        init: function(){
            return MainController.__super__.init.apply(this, arguments);
        }
    });

    return MainController;

})(appCustomerSpace.Controllers.MainController);
